import {forEach} from 'lodash';
import ReferralsService from 'top20common/distribution/services/referrals';
import commonUtils from 'top20common/distribution/utils';

export default {
  fetchReferralsAction(context) {
    context.commit('mutateReferralsLoadingState', true);
    return new Promise((resolve, reject) => {
      ReferralsService.getReferrals()
        .then(response => {
          context.commit('mutateReferralsLoadingState', false);
          context.commit('setReferralsState', response.data.results);
          context.commit('setReferralsMetaState', response.data.meta);
          context.commit('mutateReferralsErrorState', null);
          resolve(response.data.results);
        })
        .catch(error => {
          let errors = [];
          forEach(error.response.data.errors, value => {
            errors.push(value[0]);
          });
          context.commit('mutateReferralsLoadingState', false);
          context.commit('mutateReferralsErrorState', errors.join('. '));
        });
    });
  },
  getReferralDetailsAction(context, slug) {
    context.commit('mutateReferralsLoadingState', true);
    return new Promise((resolve, reject) => {
      ReferralsService.getReferralDetails(slug)
        .then(response => {
          context.commit('mutateReferralsLoadingState', false);
          context.commit('setReferralDetailsState', response.data.result);
          context.commit('setReferralsMetaState', response.data.meta);
          context.commit('mutateReferralsErrorState', null);
          resolve(response.data.result);
        })
        .catch(error => {
          context.commit('mutateReferralsLoadingState', false);
          context.commit('mutateReferralsDetailsErrorState', commonUtils.getErrorMessageFromResponse(error.response));
        });
    });
  },
  getReferrerAction(context) {
    context.commit('mutateReferrerLoadingState', true);
    return new Promise((resolve, reject) => {
      ReferralsService.getReferrer()
        .then(response => {
          context.commit('setReferrerState', response.data);
          resolve(response.data);
        })
        .catch(() => {})
        .finally(() => {
          context.commit('mutateReferrerLoadingState', false);
        });
    });
  },
  referByEmailAction(context, data) {
    context.commit('updateReferEmailsLoadingState', true);
    return new Promise((resolve, reject) => {
      ReferralsService.referByEmail(data)
        .then(response => {
          context.commit('updateReferEmailsLoadingState', false);

          resolve({
            emailsCount: context.getters.referralInviteEmailsCountState
          });
        })
        .catch(error => {
          context.commit('updateReferEmailsLoadingState', false);
          reject(error.response.data.errors);
        });
    });
  },
  updateReferralEventsAction(context, {slug, data}) {
    return ReferralsService.updateReferralEvents(slug, data);
  },
  reviewReferralAction(context, slug) {
    const data = {need_review: false};
    return context.dispatch('updateReferralEventsAction', {slug, data});
  }
};
